namespace Matrix.DataAudit {
    export interface SecurityHistoryGetDateMatchRequest extends Serenity.ServiceRequest {
        SecurityId?: number;
        StartDate?: string;
        EndDate?: string;
    }
}
